import React from "react";

export default function CompassIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 1.66663C5.39763 1.66663 1.66667 5.39759 1.66667 9.99996C1.66667 14.6023 5.39763 18.3333 10 18.3333C14.6024 18.3333 18.3333 14.6023 18.3333 9.99996C18.3333 5.39759 14.6024 1.66663 10 1.66663ZM13.2906 7.7635C13.3904 7.46406 13.3125 7.13392 13.0893 6.91073C12.8661 6.68753 12.536 6.6096 12.2365 6.70941L8.4865 7.95941C8.23767 8.04236 8.0424 8.23762 7.95946 8.48646L6.70946 12.2365C6.60964 12.5359 6.68758 12.866 6.91077 13.0892C7.13397 13.3124 7.46411 13.3904 7.76355 13.2906L11.5136 12.0406C11.7624 11.9576 11.9577 11.7623 12.0406 11.5135L13.2906 7.7635Z"
        fill="#45486E"
      />
    </svg>
  );
}
